import { render, staticRenderFns } from "./CtrlRegionalModelMixChart.vue?vue&type=template&id=2719896e&scoped=true&"
import script from "./CtrlRegionalModelMixChart.vue?vue&type=script&lang=js&"
export * from "./CtrlRegionalModelMixChart.vue?vue&type=script&lang=js&"
import style0 from "./CtrlRegionalModelMixChart.vue?vue&type=style&index=0&id=2719896e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719896e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
